import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TncDialogComponent } from './tnc-dialog/tnc-dialog.component';
import { LogoutConfirmationDialogComponent } from './logout-confirmation-dialog/logout-confirmation-dialog.component';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss'],
})
export class TncComponent implements OnInit, AfterViewInit {
  areaOptions: string[] = ['Urban', 'Rural', 'Suburban'];
  hasAcceptedTerms = false;


  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public tncFormDialogRef: MatDialogRef<TncComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  register(): void {

  }

  openLogoutDialog(): void {
    const dialogRef = this.dialog.open(LogoutConfirmationDialogComponent);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.onClose();
      }
    });
  }

  onClose(): void {
    this.tncFormDialogRef.close();
  }


  openTncDialog(): void {
    const dialogRef = this.dialog.open(TncDialogComponent, {
      width: '800px',
      disableClose: true,
      data: { message: 'Hello from App Component!' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.hasAcceptedTerms = result;
      }
    });
  }
}
